import { MAX_AUDIO_BYTES, MAX_IMAGE_BYTES, MAX_VIDEO_BYTES } from "../constants";
import type { MediaType } from "../types/app";
import { blobToArrayBuffer } from "./blob";

const signatures: Record<string, number[][]> = {
  "image/jpeg": [[0xff, 0xd8, 0xff]],
  "image/png": [[0x89, 0x50, 0x4e, 0x47]],
  "image/webp": [[0x52, 0x49, 0x46, 0x46]],
  "video/mp4": [[0x00, 0x00, 0x00], [0x66, 0x74, 0x79, 0x70]],
  "video/webm": [[0x1a, 0x45, 0xdf, 0xa3]],
  "audio/mpeg": [[0xff, 0xfb], [0x49, 0x44, 0x33]],
  "audio/wav": [[0x52, 0x49, 0x46, 0x46]],
  "audio/x-wav": [[0x52, 0x49, 0x46, 0x46]],
  "audio/mp4": [[0x00, 0x00, 0x00], [0x66, 0x74, 0x79, 0x70]],
  "audio/m4a": [[0x00, 0x00, 0x00], [0x66, 0x74, 0x79, 0x70]],
};

export function maxBytesForType(type: MediaType): number {
  if (type === "image") return MAX_IMAGE_BYTES;
  if (type === "video") return MAX_VIDEO_BYTES;
  return MAX_AUDIO_BYTES;
}

export async function validateMediaFile(file: File, type: MediaType): Promise<{ ok: true } | { ok: false; reason: string }> {
  if (file.size > maxBytesForType(type)) return { ok: false, reason: "メディア容量超過です。" };
  const allowed =
    type === "image"
      ? ["image/jpeg", "image/png", "image/webp"]
      : type === "video"
        ? ["video/mp4", "video/webm"]
        : ["audio/wav", "audio/x-wav", "audio/mpeg", "audio/mp4", "audio/m4a"];
  if (!allowed.includes(file.type)) return { ok: false, reason: type === "audioSample" ? "音声ファイル形式非対応です。" : "ファイル形式非対応です。" };

  const header = new Uint8Array(await blobToArrayBuffer(file.slice(0, 16)));
  const sigs = signatures[file.type] ?? [];
  const hasSignature = sigs.some((sig) => {
    if (file.type.includes("mp4") || file.type.includes("m4a")) {
      return header.includes(0x66) && header.includes(0x74) && header.includes(0x79) && header.includes(0x70);
    }
    return sig.every((byte, index) => header[index] === byte);
  });
  return hasSignature ? { ok: true } : { ok: false, reason: "ファイルの内容を確認できませんでした。" };
}
